<script setup lang="ts">
import { IconCloseRegular } from "@packages/icon-library";
import { UiIconButton, UiSkeleton } from "@packages/component-library";

const emit = defineEmits(["close"]);
</script>

<template>
  <div class="earn-deduct-loading">
    <div class="earn-deduct-loading__qr">
      <UiSkeleton />

      <UiSkeleton />
    </div>

    <UiSkeleton />

    <UiIconButton size="m" color="primary" @click="emit('close')">
      <IconCloseRegular />
    </UiIconButton>
  </div>
</template>

<style scoped lang="scss">
.earn-deduct-loading {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  &__qr {
    border-radius: 12px;
    background-color: var(--color-semantic-background-normal-bg-primary);
    padding: calc($base-space * 8) ($base-space * 6);
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;

    > .ui-skeleton {
      &:nth-child(1) {
        width: 220px;
        height: 220px;
      }
      &:nth-child(2) {
        width: 220px;
        height: 48px;
        margin: calc($base-space * 22.5) 0 0;
      }
    }
  }

  > .ui-skeleton {
    width: 170px;
    height: 40px;
    margin: calc($base-space * 8) 0 0;
  }

  > button {
    margin: calc($base-space * 6) 0 0;
  }
}
</style>
